import { useEffect } from 'react';

/**
 * Endereço incompleto (ex.: `#/caso` sem id, `#/cupom` sem id) leva para a lista de origem.
 *
 * Troca o hash com `replace`, sem deixar a rota quebrada no histórico — o "voltar" do navegador
 * não cai de novo aqui. Enquanto troca, não desenha nada (nunca uma tela "em construção").
 */
export function Redirecionar({ para }: { para: string }) {
  useEffect(() => {
    window.location.replace(para);
  }, [para]);
  return null;
}
